export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=409e98a3ab2e6715cae32e13818f180cb3eb31a6b5&name=revalidateCommunity!'